import { render, staticRenderFns } from "./EditTagModal.vue?vue&type=template&id=0d79d304&scoped=true&"
import script from "./EditTagModal.vue?vue&type=script&lang=ts&"
export * from "./EditTagModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d79d304",
  null
  
)

export default component.exports